// @ts-expect-error
import select from 'select';
import sleep from '../sleep';
function command(type) {
    try {
        return document.execCommand(type);
    }
    catch (err) {
        return false;
    }
}
function createFakeElement(value, readonly = true) {
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    const fakeElement = document.createElement('textarea');
    // Prevent zooming on iOS
    fakeElement.style.fontSize = '12pt';
    // Reset box model
    fakeElement.style.border = '0';
    fakeElement.style.padding = '0';
    fakeElement.style.margin = '0';
    // Move element out of screen horizontally
    fakeElement.style.position = 'absolute';
    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px';
    fakeElement.style.width = '100px';
    fakeElement.style.height = '100px';
    // Move element to the same position vertically
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    fakeElement.style.top = `${yPosition}px`;
    readonly && fakeElement.setAttribute('readonly', '');
    fakeElement.setAttribute('contentEditable', 'true');
    fakeElement.value = value;
    return fakeElement;
}
export default {
    setString: (text) => {
        if (navigator?.permissions && navigator?.clipboard?.writeText) {
            return navigator.clipboard.writeText(text);
        }
        return new Promise(async (resolve, reject) => {
            const fakeElement = createFakeElement(text);
            document.body.appendChild(fakeElement);
            fakeElement.addEventListener('click', async () => {
                select(fakeElement);
                const status = command('copy');
                await sleep(1000);
                fakeElement.remove();
                if (status) {
                    resolve(null);
                }
                else {
                    reject(new Error('not support'));
                }
            });
            await sleep(10);
            fakeElement.click();
        });
    },
    getString: async () => {
        if (navigator?.permissions && navigator?.clipboard?.readText) {
            return navigator.clipboard.readText();
        }
        const fakeElement = createFakeElement('', false);
        document.body.appendChild(fakeElement);
        const status = command('paste');
        await new Promise((resolve) => setTimeout(resolve, 200));
        fakeElement.remove();
        if (status) {
            const value = fakeElement.value;
            return value;
        }
        else {
            return Promise.reject(new Error('not support'));
        }
    },
};
